/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integration_File_ErrorInputs */

const en_integration_file_error = /** @type {(inputs: Integration_File_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This file could not be added. Please try again.`)
};

const es_integration_file_error = /** @type {(inputs: Integration_File_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo añadir este archivo. Inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "This file could not be added. Please try again." |
*
* @param {Integration_File_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const integration_file_error = /** @type {((inputs?: Integration_File_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integration_File_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_integration_file_error(inputs)
	return en_integration_file_error(inputs)
});